var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.$emit('click')}}},[_c('div',{staticClass:"d-flex align-center justify-center"},[_vm._t("default"),_vm._v(" "),(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin ml-1"}):_vm._e()],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e215932","hasScoped":false,"optionsId":"29","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/vkb-btn.vue
// module id = hump
// module chunks = 0